var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{attrs:{"id":"PrivacyPolicy"}},[_c('Hero',[_c('h1',[_vm._v(_vm._s(_vm.privacyPolicy.title))]),_c('HeroScrollDown',{attrs:{"slot":"outside","hash":"#policy"},slot:"outside"})],1),_c('section',{attrs:{"id":"policy"}},[_c('Wrap',[_c('Markdown',{attrs:{"markdown":_vm.privacyPolicy.content}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }